<div class="py-8" *transloco="let t">
  <div class="mb-6 flex flex-col gap-1">
    <h4>{{ t("sb-form-setup.title") }}</h4>
    <p class="type-body text-muted-foreground m-0">{{ t("sb-form-setup.description") }}</p>
  </div>

  <div class="flex flex-col gap-6">
    @if (!hideName()) {
      <IFormField>
        <label iLabel>{{ t("common.name") }}</label>
        <input
          iInput
          [formField]="setup().name"
          size="sm"
          [placeholder]="t('common.name')"
          data-testid="strategy-name-input"
        />
        <IError>{{ t("dsp-create-strategy-page.name_is_required") }}</IError>
      </IFormField>
    }

    @if (!isVendor()) {
      <IFormField>
        <label iLabel>{{ t("common.brand") }}</label>
        @if (brands().length > 0) {
          <ISelectMenu
            [value]="setup().brand().value()"
            (valueChange)="selectBrand($event)"
            by="brandEntityId"
            [(searchQuery)]="searchQuery"
            fitTriggerWidth
            class="sensitive-data"
            data-testid="brand-selection"
          >
            <ISelectTrigger class="flex w-full">
              <ISelectValue [placeholder]="t('brand-merge-modal.select_brand')">
                <div *iSelectValue="let brand">{{ brand.brandName }}</div>
              </ISelectValue>
            </ISelectTrigger>
            <ISelectContent>
              @for (brand of filteredBrands(); track brand.brandEntityId) {
                <ISelectOption
                  [value]="brand"
                  [attr.data-testid]="'brand-selection-' + (brand.brandName?.replaceAll(' ', '_') ?? '')"
                >
                  {{ brand.brandName }}
                </ISelectOption>
              }
            </ISelectContent>
          </ISelectMenu>
        } @else {
          <p class="type-label text-muted-foreground m-0">{{ t("sb-form-info.no_brands_available") }}</p>
        }
        <IError>{{ t("sb-form-setup.brand_is_required") }}</IError>
      </IFormField>
    }

    @if (!hideAlgo()) {
      <div class="flex flex-col gap-2">
        <div class="type-label text-muted-foreground">{{ t("dsp-create-strategy-page.algorithm") }}</div>
        <app-algo-mode-selection
          [currencyCode]="currencyCode()"
          [selectedAlgoModeConfig]="setup().algo().value() ?? undefined"
          (algoModeConfig)="selectAlgoModeConfig($event)"
        />
      </div>
    }
  </div>
</div>
